module.exports = "/_next/static/images/7c02746b8aab44be38544f81d2cfec0d-listen-circle.svg";